import React from "react";

export default function ScientificSlider({ text, image }) {
  return (
    <section className="scientific">
      <img src={image} alt={text} className="scientific__image" />
      {/* <div className="slider__description">
        <p className="history__photo_text">{text}</p>
      </div> */}
    </section>
  );
}
